var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Decorators for classes and props
import { Vue, Component, Mixins } from 'vue-property-decorator';
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
import { VendorService } from '@/services/vendor-service';
// Validation
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
// Components
import LayoutMixin from '@/mixins/layout-mixin';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import PartialSaveMixin from '@/mixins/partial-save-mixin';
import { ValidationObserver } from 'vee-validate';
import DetailsStep from '@/pages/vendor-management/AddEditVendor/DetailsStep.vue';
var AdditionalInfoStep = function () { return import('@/pages/vendor-management/AddEditVendor/AdditionalInfoStep.vue'); };
var SiteAssociationsStep = function () { return import('@/pages/vendor-management/AddEditVendor/SiteAssociationsStep.vue'); };
var AddEditVendor = /** @class */ (function (_super) {
    __extends(AddEditVendor, _super);
    function AddEditVendor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // validations
        _this.validationRules = {};
        return _this;
    }
    /**
     * Lifecycle Events
     */
    AddEditVendor.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.validationRules = this.vendorService.getValidationRules();
                this.item = this.vendorService.getDefault();
                return [2 /*return*/];
            });
        });
    };
    AddEditVendor.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var readonly, getByIdResponse, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vendorService.canEditPage(this.$route.meta.authorize)];
                    case 1:
                        readonly = (_a.sent()) === false;
                        this.readonly = readonly;
                        if (!this.isExistingVendor) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.vendorService.getById(this.$route.params.id)];
                    case 2:
                        getByIdResponse = _a.sent();
                        if (getByIdResponse.success) {
                            this.item = getByIdResponse.data;
                        }
                        else {
                            this.item = this.vendorService.getDefault();
                        }
                        _a.label = 3;
                    case 3:
                        // load the partial data back in to page
                        if (this.isExistingVendor === false && this.restoringPartialSave) {
                            data = __assign({}, this.getDataToBeRestored());
                            this.item = data;
                        }
                        // reset the step to be the first one
                        this.step = 'D';
                        return [2 /*return*/];
                }
            });
        });
    };
    AddEditVendor.prototype.getErrorsForStep = function (errors, index) {
        if (Object.keys(errors).length <= index) {
            return [];
        }
        return errors[Object.keys(errors)[index]];
    };
    Object.defineProperty(AddEditVendor.prototype, "isExistingVendor", {
        get: function () {
            return this.$route.params && this.$route.params.id && this.$route.params.id !== '0';
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        lazyInject(TYPES.VendorService),
        __metadata("design:type", typeof (_a = typeof VendorService !== "undefined" && VendorService) === "function" ? _a : Object)
    ], AddEditVendor.prototype, "vendorService", void 0);
    AddEditVendor = __decorate([
        Component({
            components: {
                ValidationObserver: ValidationObserver,
                DetailsStep: DetailsStep,
                AdditionalInfoStep: AdditionalInfoStep,
                SiteAssociationsStep: SiteAssociationsStep,
            },
            $_veeValidate: { validator: 'new' },
        })
    ], AddEditVendor);
    return AddEditVendor;
}(Mixins(LayoutMixin, SteppedPageMixin, PartialSaveMixin)));
export default AddEditVendor;
